export enum ProblemType {
  DIAGNOSIS = 'D',
  FINDING = 'F',
}
